import { useState } from "react";
import { Card, Image } from "react-bootstrap";
import { toast } from "react-toastify";

import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { fileToBase64 } from "../utils";
import { BlockInput } from "./blockInput";

export const handleFileInput =
	({
		handleSuccess = (_result) => {},
		handleError = console.error,
		setIsLoading = () => {},
		sizeLimit = 131072 /* 1024 bytes/KB * 128KB */,
	}) =>
	async (e) => {
		try {
			// handle validations
			if (!e.target.files || !e.target.files.length) return;

			const file = e.target.files[0];

			if (file.size > sizeLimit /* 1024 bytes/KB * 128KB */) {
				toast.error("File size is too large");
			} else {
				setIsLoading(true);

				const response = await fileToBase64(file);
				await handleSuccess(response);
				return response;
			}
		} catch (error) {
			handleError(error);
		} finally {
			setIsLoading(false);
		}
	};

export const ChoosePhotoWidget = ({
	title,
	photo,
	handleSuccess = (_result) => {},
	handleError = console.error,
}) => {
	const [isLoading, setIsLoading] = useState(false);

	return (
		<Card
			border="light"
			data-testid="test-choosePhotoWidget"
			className="bg-white choosePhotoWidget shadow-sm mb-4"
		>
			<BlockInput blocking={isLoading} />
			<Card.Body>
				<h5 className="mb-4">{title}</h5>
				<div className="d-flex align-items-center">
					<input
						type="file"
						accept=".jpeg,.jpg,.png"
						title="Choose an image"
						onChange={handleFileInput({
							handleSuccess,
							handleError,
							setIsLoading,
						})}
					/>
					<div className="user-avatar xl-avatar me-2">
						<Image fluid src={photo} />
					</div>
					<div className="d-flex justify-content-xl-center">
						<div className="d-flex">
							<span className="icon icon-md">
								<FontAwesomeIcon
									icon={faPaperclip}
									className="me-3"
								/>
							</span>
							<div className="d-md-block text-start">
								<div className="fw-normal text-dark mb-1">
									Choose Image
								</div>
								<div className="text-gray small">
									JPG or PNG. Max size of 128KB
								</div>
							</div>
						</div>
					</div>
				</div>
			</Card.Body>
		</Card>
	);
};
